function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useMemo } from 'react';
import { useGrid } from '../../../hook';
import { FilterType } from '../../../../../common/utils/data';
import AutoComplete from '../../../../Fields/AutoComplete';
import FilterTemplate from '../../FilterTemplate';

const GRAPH = ({
  dataIndex,
  md,
  sm,
  lg,
  xl,
  inColumn,
  isFilterParameter,
  manageDefaultOptions,
  onChange: CustomFilter,
  multiple,
  ...props
}) => {
  const type = isFilterParameter ? FilterType.PARAMETER : multiple ? FilterType.MULTIPLE : FilterType.DROPDOWN;
  const {
    filterProps,
    filters
  } = useGrid();
  const {
    onChange
  } = filterProps({
    dataIndex,
    type,
    autoSubmit: true,
    multiple
  });
  const filterData = useMemo(() => filters.find(filter => `${dataIndex}` === `${filter.dataIndex}` && filter.type === type), [filters]);
  const defaultOptions = useMemo(() => {
    return manageDefaultOptions ? manageDefaultOptions(filterData?.value) : true;
  }, [filterData]);
  return /*#__PURE__*/React.createElement(FilterTemplate, {
    md: md,
    sm: sm,
    lg: lg,
    xl: xl,
    inColumn: inColumn
  }, /*#__PURE__*/React.createElement(AutoComplete.Async.Graph, _extends({
    name: `${dataIndex}`,
    value: filterData?.value,
    onChange: CustomFilter || onChange,
    multiple: multiple,
    defaultOptions: defaultOptions
  }, props)));
};

export default GRAPH;